export default __webpack_public_path__ + "static/media/tableCorner.3b35aa59.svg";